import React from 'react';
import {
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    tableCellClasses,
} from '@mui/material';

// --- ESTILIZAÇÃO PERSONALIZADA ---

// 1. Célula de Cabeçalho (Header Cell)
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // Estilo do Cabeçalho
        backgroundColor: theme.palette.primary.main, // Cor principal do seu tema MUI
        color: theme.palette.common.white,
        fontWeight: 'bold',
        fontSize: 16,
        padding: '16px',
        borderBottom: 'none',
    },
}));

// 2. Linha do Corpo (Body Row) com Efeito Zebrado (Striped)
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // Efeito Zebrado: aplica estilo para linhas ímpares
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover, // Cor cinza suave
    },
    // Esconde a última borda inferior (para um visual limpo)
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    // Efeito Hover
    '&:hover': {
        backgroundColor: theme.palette.secondary.light, // Cor mais clara no hover
    },
    cursor: 'pointer',
}));

// 3. Contêiner da Tabela (para cantos arredondados)
const StyledTableContainer = styled(TableContainer)({
    borderRadius: '12px', // Cantos arredondados
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    overflowX: 'auto', // Garante o scroll horizontal em telas pequenas
});

const CustomMuiTable = ({ columns, data }) => {
    return (
        <StyledTableContainer component={Paper}>
            <Table stickyHeader aria-label="customized table">
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <StyledTableCell key={column.field} align={column.align || 'left'}>
                                {column.headerName}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row) => (
                        <StyledTableRow key={row.id}>
                            {columns.map((column) => (
                                <TableCell key={column.field} align={column.align || 'left'}>
                                    {/* Renderiza o valor do dado ou um componente customizado */}
                                    {column.renderCell ? column.renderCell(row) : row[column.field]}
                                </TableCell>
                            ))}
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};

export default CustomMuiTable;